var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("健康在线")]),
              _c("el-breadcrumb-item", [_vm._v("反馈列表")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              ref: "listForm",
              attrs: {
                model: _vm.listParams,
                "label-width": "120px",
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "回复状态：", prop: "replyStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "请选择回复状态",
                      },
                      model: {
                        value: _vm.listParams.replyStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "replyStatus", $$v)
                        },
                        expression: "listParams.replyStatus",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.title,
                        attrs: { label: item.title, value: item.replyStatus },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.loadTableData },
                    },
                    [_vm._v(" 查询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("listForm")
                        },
                      },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "600",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", align: "center", label: "id" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "反馈标题" },
              }),
              _c("el-table-column", {
                attrs: { prop: "category", align: "center", label: "反馈模块" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiver",
                  align: "center",
                  label: "反馈接收单位",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "creator", align: "center", label: "反馈用户" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "replyStatusTxt",
                  align: "center",
                  label: "回复状态",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "contact", align: "center", label: "联系方式" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsSites",
                  align: "center",
                  label: "供应点",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userMsgCount",
                  align: "center",
                  label: "反馈次数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "publishTime",
                  align: "center",
                  label: "反馈时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.publishTime
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(scope.row.publishTime)
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastReplyBy",
                  align: "center",
                  label: "操作人",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.linkToDetailPage(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }